
import { EnhancedMeetingScheduler } from "@/components/team/EnhancedMeetingScheduler";
import { EnhancedTeamMeetings } from "@/components/team/EnhancedTeamMeetings";
import { Helmet } from "react-helmet";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useEffect } from "react";
import { useNotificationCounts } from "@/hooks/use-notification-counts";

const TeamMeetings = () => {
  const { resetCount } = useNotificationCounts();

  useEffect(() => {
    // Reset notification count when visiting this page
    resetCount("team_meetings");
  }, []);

  return (
    <div className="container py-6 space-y-6">
      <Helmet>
        <title>Team Meetings - Spotlight Adz</title>
      </Helmet>
      
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Team Meetings</h1>
          <p className="text-muted-foreground mt-2">
            Schedule team meetings, invite members, and manage upcoming meetings.
          </p>
        </div>
      </div>

      <Tabs defaultValue="all-meetings" className="w-full">
        <TabsList>
          <TabsTrigger value="all-meetings">All Team Meetings</TabsTrigger>
          <TabsTrigger value="schedule">Schedule Meeting</TabsTrigger>
        </TabsList>
        <TabsContent value="all-meetings" className="mt-6">
          <EnhancedTeamMeetings />
        </TabsContent>
        <TabsContent value="schedule" className="mt-6">
          <EnhancedMeetingScheduler />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default TeamMeetings;
